export default "__VITE_ASSET__BT9ZSSvb__"